import * as React from "react"
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg"

function SvgComponent() {
  return (
    <Svg
      width={353}
      height={222}
      viewBox="0 0 353 222"
      fill="none"
    >
      <G clipPath="url(#clip0_5028_4425)">
        <Path
          d="M273.501 186.098l9.998-3.135c-4.46.238-6.693.357-11.165.599 2.448-4.321 3.544-6.45 5.483-10.595a304.668 304.668 0 01-7.299 8.188c-.846-4.994-1.907-9.347-3.478-14.155.738 4.025 1.057 8.374.955 12.464l-.208.038a100.392 100.392 0 00-10.755-10.668 81.537 81.537 0 019.739 13.008 362.326 362.326 0 00-12.573-4.547 310.787 310.787 0 0112.483 7.303l-10.34 3.341c4.281-.264 6.419-.395 10.691-.655a245.247 245.247 0 01-5.846 6.736 949.729 949.729 0 007.423-5.014c-.41 3.278-.703 4.94-1.468 8.284 1.462-3.383 2.108-5.065 3.234-8.385 2.098 10.186 1.554 20.06-.475 30.186l2.515-.461c1.469-10.382 1.089-19.678-1.18-29.883 2.533 2.651 3.717 3.998 5.913 6.71-1.521-2.925-2.371-4.378-4.248-7.237 3.601.801 5.383 1.206 8.91 2.022a252.3 252.3 0 00-8.309-4.144z"
          fill="#EBEBEB"
        />
        <Path
          d="M277.048 189.618l-9.246-4.974c4.339 1.079 6.51 1.619 10.859 2.703-1.611-4.709-2.295-7.007-3.438-11.446a306.438 306.438 0 005.665 9.426c1.75-4.747 3.592-8.821 6.021-13.248-1.466 3.814-2.579 8.027-3.231 12.064l.197.077a99.867 99.867 0 0112.528-8.444 80.981 80.981 0 00-11.961 10.934c4.38-.776 8.784-1.472 13.189-2.086a309.258 309.258 0 00-13.607 4.811l9.544 5.24c-4.158-1.069-6.234-1.603-10.383-2.668 1.719 3.054 2.618 4.6 4.503 7.725a934.29 934.29 0 01-6.37-6.331c-.2 3.298-.218 4.987-.081 8.417-.814-3.601-1.139-5.375-1.635-8.851-3.936 9.61-5.218 19.414-5.087 29.746l-2.386-.929c.466-10.478 2.55-19.538 6.655-29.135-2.976 2.125-4.386 3.224-7.043 5.472 2.033-2.585 3.135-3.851 5.505-6.305-3.685.105-5.51.165-9.126.299a252.37 252.37 0 018.928-2.497z"
          fill="#E6E6E6"
        />
        <Path
          d="M268.005 195.2l6.739-3.625-7.916 1.97c1.175-3.433 1.674-5.109 2.507-8.345a224.094 224.094 0 01-4.129 6.872 68.733 68.733 0 00-4.39-9.657 44.898 44.898 0 012.355 8.794 6.147 6.147 0 01-.144.056 72.57 72.57 0 00-9.133-6.156 59.015 59.015 0 018.72 7.972A264.6 264.6 0 00253 191.56a226.114 226.114 0 019.919 3.507l-6.957 3.82c3.03-.78 4.544-1.168 7.568-1.945a180.764 180.764 0 01-3.283 5.631 678.644 678.644 0 004.644-4.615c.146 2.404.159 3.635.059 6.135.593-2.624.831-3.918 1.192-6.451 2.869 7.005 3.803 14.152 3.708 21.683l1.739-.676c-.34-7.638-1.859-14.243-4.852-21.239 2.169 1.549 3.198 2.35 5.134 3.989-1.481-1.884-2.285-2.807-4.012-4.596 2.686.076 4.016.12 6.652.218a179.232 179.232 0 00-6.506-1.821z"
          fill="#E6E6E6"
        />
        <Path
          d="M265.392 243.756h16.248l1.59-26.257h-19.428l1.59 26.257z"
          fill="#E0E0E0"
        />
        <Path
          d="M262.544 218.854h22.105l.398-3.492h-22.901l.398 3.492zM282.4-26.634h34.302v45.212H282.4v-45.212z"
          fill="#F5F5F5"
        />
        <Path d="M285.039-23.156h29.023V15.1h-29.023v-38.256z" fill="#EBEBEB" />
        <Path
          d="M286.855-20.762h25.392v33.468h-25.392v-33.468z"
          fill="#FAFAFA"
        />
        <Path d="M250.737 24.646h34.302V54.31h-34.302V24.646z" fill="#EBEBEB" />
        <Path d="M253.376 26.928H282.4v25.1h-29.024v-25.1z" fill="#F5F5F5" />
        <Path
          d="M255.192 28.499h25.391v21.958h-25.391V28.499z"
          fill="#FAFAFA"
        />
        <Path
          d="M245.841 16.021V-7.912h30.648v23.933h-30.648z"
          fill="#E6E6E6"
        />
        <Path d="M248.199 14.18V-6.07h25.932v20.25h-25.932z" fill="#F0F0F0" />
        <Path
          d="M249.822 12.913V-4.803h22.686v17.716h-22.686z"
          fill="#EBEBEB"
        />
        <Path
          d="M30.97 210.874H7.603c-4.2 0-7.603-3.454-7.603-7.713v-34.659c0-.778.622-1.408 1.388-1.408.767 0 1.388.63 1.388 1.408v34.659c0 2.704 2.161 4.896 4.827 4.896H30.97v2.817z"
          fill="#E0E0E0"
        />
        <Path
          d="M37.652 244.093v-32.276l1.867-.598c2.102-.671 3.531-2.648 3.531-4.884H25.423c0 2.236 1.429 4.212 3.53 4.884l1.868.598v32.276l-14.658 6.684v2.817l18.074-6.41 18.073 6.41v-2.817l-14.658-6.684z"
          fill="#E0E0E0"
        />
        <Path
          d="M57.287 208.054H11.186c-2.762 0-5.001-2.271-5.001-5.074 0-2.801 2.238-5.073 5-5.073h46.102c2.762 0 5.001 2.271 5.001 5.073 0 2.803-2.24 5.074-5 5.074z"
          fill="#F0F0F0"
        />
        <Path
          d="M3.054 180.699L.567 144.61c-.193-2.796 1.885-5.22 4.64-5.416 2.755-.195 5.145 1.912 5.338 4.708l2.487 36.089c.193 2.795-1.885 5.221-4.64 5.416-2.755.194-5.145-1.913-5.338-4.708z"
          fill="#EBEBEB"
        />
        <Path
          d="M93.26 169.789H64.374v-3.513l28.885-1.878v5.391z"
          fill="#E0E0E0"
        />
        <Path d="M135.985 185.367h-85.45v-12h85.45v12z" fill="#F0F0F0" />
        <Path d="M153.697 176.945H33.127v-7.155h120.57v7.155z" fill="#FAFAFA" />
        <Path
          d="M142.496 259.836h5.448l-9.425-82.891h-6.385l10.362 82.891zM54.69 176.945h-6.385l-9.426 82.891h5.448l10.363-82.891z"
          fill="#E6E6E6"
        />
        <Path
          d="M122.515 168.006l-7.404-37.314c-.352-1.775-3.029-1.024-2.677.749l7.05 35.531h-15.272c-1.787 0-1.79 2.817 0 2.817h16.965c.952 0 1.514-.896 1.338-1.783z"
          fill="#E0E0E0"
        />
        <Path
          d="M105.234 157.997L109.99 89c3.568 2.592 5.556 6.878 5.25 11.32l-3.254 47.209c-.306 4.442-2.862 8.405-6.752 10.468z"
          fill="#FAFAFA"
        />
        <G opacity={0.5} fill="#fff">
          <Path d="M133 163.297c0 .524.419.949.936.949a.942.942 0 00.935-.949.942.942 0 00-.935-.95.943.943 0 00-.936.95zM133.001 166.157c0 .524.418.949.935.949a.943.943 0 00.936-.949.943.943 0 00-.936-.949.943.943 0 00-.935.949zM133.001 169.018c0 .525.418.95.935.95a.943.943 0 00.936-.95.943.943 0 00-.936-.949.942.942 0 00-.935.949z" />
        </G>
        <Path
          d="M276.292 105.023s14.485 1.601 21.06.248c6.574-1.352 12.81-12.416 12.81-12.416l-7.082-4.629-8.052 10.542-18.421 1.709-4.982-4.137-5.239 1.274s-.119 6.62 2.113 6.972c2.232.353 7.793.437 7.793.437z"
          fill="#FFC3BD"
        />
        <Path
          d="M311.967 76.495s-4.358-.106-8.993 7.341c-1.565 2.514-2.15 3.993-2.618 5.25-.624 1.677 2.536 3.682 4.815 5.173 1.771 1.16 3.647 2.4 4.751 2.217 0 0 1.284-1.585 2.217-3.84 1.917-4.636 3.928-16.337-.172-16.141z"
          fill="#407BFF"
        />
        <Path
          opacity={0.2}
          d="M312.958 90.516l-2.007-4.985-1.455-1.211s-3.165 6.158-2.927 10.893c2.455 1.526 3.941 1.361 5.569-2.578.247-.594.527-1.315.82-2.119z"
          fill="#000"
        />
        <Path
          d="M309.144 77.414s.148 6.817.563 10.293c.515 4.355 1.709 8.092 5.134 14.333a5026.926 5026.926 0 018.677 15.896l26.298-11.056s-4.416-10.647-7.051-20.66c-.896-3.41-1.585-6.753-1.823-9.562-.163-1.942-.508-3.528-.99-4.8-2.082-5.432-6.79-5.297-11.494-3.778a3.7 3.7 0 01-.003.314c-.101 3.9-4.553 10.553-5.807 11.05-1.573.629-6.472-2.104-6.535-5.808.005-.08.002-.152.007-.232-2.892 1.416-6.976 4.01-6.976 4.01z"
          fill="#407BFF"
        />
        <Path
          opacity={0.9}
          d="M325.385 67.39l5.363.202 3.405 5.988-4.951.796-5.962 6.48-7.957-1.663-3.554.875 1.202-5.611 5.675-4.332 6.779-2.735z"
          fill="#fff"
        />
        <Path
          d="M316.113 73.635c.063 3.704 4.961 6.437 6.534 5.808 1.255-.497 5.707-7.151 5.808-11.05-.839.095-1.818-.08-2.688-.975-2.204-2.665-3.575-7.456-4.196-10.48l-4.313 8.81c1.118 1.55 1.553 3.662 1.028 5.297-.032.07-.205 1.334-2.173 2.59z"
          fill="#FFC3BD"
        />
        <Path
          opacity={0.1}
          d="M318.315 63.59l-1.057 2.16a6.677 6.677 0 011.193 3.073c2.661-2.786 3.258-7.535 3.258-7.535l-3.394 2.303z"
          fill="#000"
        />
        <Path
          opacity={0.2}
          d="M334.968 74.39s3.143 6.626 7.797 11.83c-.896-3.41-1.585-6.753-1.823-9.562-.163-1.942-.508-3.528-.99-4.8l-2.709-.653-2.275 3.184z"
          fill="#000"
        />
        <Path
          d="M349.052 73.306s8.553 6.84 11.131 9.424c3.84 3.85 14.032 16.65 14.032 16.65l6.484 4.203-.287 4.321-3.333 2.016a2.128 2.128 0 01-2.956-.783l-3.671-6.472s-9.458-10.037-12.989-12.955c-2.984-2.466-12.79-8.695-12.79-8.695l4.379-7.71z"
          fill="#FFC3BD"
        />
        <Path
          d="M333.287 67.173s5.518-2.647 10.273.329 7.459 3.55 6.13 7.727c-.975 3.06-4.712 9.158-4.712 9.158-3.173-1.32-13.964-12.94-11.691-17.214zM352.001 111.032l-1.624-4.208c-.111-.54-.354-.881-.855-.666l-26.283 11.262c-.482.207-.553.458-.286.914l1.43 4.889s3.569 46.188 5.302 61.579c1.767 15.689 8.713 62.729 8.713 62.729a.641.641 0 00.694.565l7.851-.745a.643.643 0 00.577-.585c.353-3.946 1.955-28.926.65-46.763-.466-6.373-2.22-11.573-2.7-15.099-.529-3.891.857-6.382 1.951-15.586 2.062-17.335 4.965-44.682 4.58-58.286z"
          fill="#407BFF"
        />
        <Path
          opacity={0.7}
          d="M352.001 111.032l-1.624-4.208c-.111-.54-.354-.881-.855-.666l-26.283 11.262c-.482.207-.553.458-.286.914l1.43 4.889s3.569 46.188 5.302 61.579c1.767 15.689 8.713 62.729 8.713 62.729a.641.641 0 00.694.565l7.851-.745a.643.643 0 00.577-.585c.353-3.946 1.955-28.926.65-46.763-.466-6.373-2.22-11.573-2.7-15.099-.529-3.891.857-6.382 1.951-15.586 2.062-17.335 4.965-44.682 4.58-58.286z"
          fill="#000"
        />
        <Path
          opacity={0.5}
          d="M347.422 169.317c.689-5.797 1.473-12.714 2.195-19.861l-6.849-13.762-2.931-8.044-3.559 4.274s4.123 24.987 10.66 40.955c.163-1.069.327-2.24.484-3.562z"
          fill="#000"
        />
        <Path
          d="M331.741 120.722s17.237 49.148 25.936 64.037c7.726 13.222 38.12 47.794 38.12 47.794a1.363 1.363 0 001.888.245l4.778-3.586c.545-.409.717-1.16.402-1.768-2.465-4.775-12.886-24.64-22.307-37.747-3.758-5.229-7.451-9.122-9.203-11.985-2.31-3.775-1.52-6.626-2.873-16.765-2.514-18.853-8-46.707-18.813-51.845l-17.928 11.62z"
          fill="#407BFF"
        />
        <Path
          opacity={0.7}
          d="M331.741 120.722s17.237 49.149 25.936 64.037c7.726 13.222 37.791 47.996 37.791 47.996a1.362 1.362 0 001.888.244l5.412-4.017a.951.951 0 00.274-1.195c-2.096-4.074-12.816-24.64-22.484-38.091-3.758-5.229-7.451-9.122-9.203-11.984-2.31-3.776-1.52-6.627-2.873-16.766-2.514-18.853-8-46.706-18.813-51.845l-17.928 11.621z"
          fill="#000"
        />
        <Path
          d="M311.483 41.96c-.352 2.378-3.135 3.682-4.424 6.385 0 0-3.677-3.213-1.102-5.63 2.574-2.417 6.08-4.481 5.526-.755z"
          fill="#263238"
        />
        <Path
          d="M306.996 44.735c-2.829 1.197-4.284 6.855-.833 8.955-.055.303-.257.499-.445.388-3.925-2.305-2.459-9.522.97-12.016l.308 2.673zM313.757 47.02c2.629 2.57 4.196 6.223 4.258 9.925.062 3.701 1.783 6.146-.757 8.805-8.768 2.39-8.84 3.47-10.1 4.062-.563-1.802-.721-6.976 1.558-8.737 1.669-1.291 3.251-2.718 3.767-4.781.69-2.759.928-5.633.7-8.47l.574-.803z"
          fill="#263238"
        />
        <Path
          d="M324.066 51.289c-.511 6.434-.588 9.17-3.885 12.423-4.919 4.88-12.625 2.848-13.989-3.613-1.258-5.81-.217-15.35 6.067-17.808 4.459-1.775 9.494.454 11.244 4.978a8.91 8.91 0 01.563 4.02z"
          fill="#FFC3BD"
        />
        <Path
          d="M309.752 53.638a13.977 13.977 0 01-1.743 3.407 2.218 2.218 0 001.853.296l-.11-3.703z"
          fill="#ED893E"
        />
        <Path
          d="M311.941 60.23c-.245.03-.492.04-.738.03a.145.145 0 01-.142-.146v-.009a.159.159 0 01.15-.15 4.031 4.031 0 003.367-1.562.152.152 0 01.213-.04.158.158 0 01.04.215 4.286 4.286 0 01-2.89 1.662zM323.046 40.409c4.699 3.485 9.082 15.145-1.025 21.035-2.147-1.035-.737-3.388-.253-7.04.317-2.39-3.829-6.518-5.827-7.824-1.998-1.304-4.032-3.396-6.227-2.474-.575.241-1.166.591-1.775.465-1.998-.41-1.368-1.712-.632-2.693 1.082-1.441 2.848-2.392 4.511-2.977 3.69-1.296 8.041-.856 11.228 1.508z"
          fill="#263238"
        />
        <Path
          d="M317.289 47.518c.163 1.25.64 2.484 1.396 3.484.784 1.038 2.071 1.584 3.351 1.74 1.279.154 2.572-.038 3.846-.23a7.556 7.556 0 01-5.895.632c-1.941-.604-3.616-2.04-4.53-3.879-.453-.91-.721-1.903-1.116-2.841-.395-.939-.948-1.855-1.801-2.395-.854-.54-2.059-.603-2.813.073-.354-.046-.716-.259-.835-.6a1.015 1.015 0 01.214-1.008c1.178-.108 7.307-1.673 8.183 5.024z"
          fill="#263238"
        />
        <Path
          d="M325.322 42.8c2.628 2.57 5.13 7.436 5.193 11.138.062 3.702-1.381 7.407-3.922 10.066-2.737.368-6.213 1.77-8.503 3.693-.984-2.73.847-7.868 3.126-9.63 1.67-1.29 3.252-2.717 3.768-4.78.69-2.759.927-5.633.7-8.47l-.362-2.017z"
          fill="#263238"
        />
        <Path
          d="M325.866 56.175a4.724 4.724 0 01-2.473 2.591c-1.502.644-2.434-.67-2.215-2.214.219-1.391 1.258-3.405 2.853-3.394 1.151.03 2.061 1.001 2.032 2.17a2.136 2.136 0 01-.197.847z"
          fill="#FFC3BD"
        />
        <Path
          d="M316.136 50.577a.292.292 0 01-.336-.104c-.867-1.162-2.66-1.085-2.676-1.083a.304.304 0 01-.314-.294.304.304 0 01.29-.319c.09-.008 2.141-.059 3.19 1.34a.309.309 0 01-.053.428l-.001.001-.1.031zM306.464 50.086a.29.29 0 01-.29-.074.31.31 0 01-.017-.431l.003-.005a3.002 3.002 0 012.604-.97c.165.03.275.192.245.36a.303.303 0 01-.353.248 2.363 2.363 0 00-2.05.79.409.409 0 01-.142.082zM307.29 52.423c-.35.014-.613.478-.585 1.024.028.546.34.98.688.96.348-.022.612-.48.585-1.025-.019-.534-.338-.974-.688-.96z"
          fill="#263238"
        />
        <Path
          d="M306.138 52.146l1.314.314c-.596.676-1.314-.314-1.314-.314zM313.415 52.275c-.35.014-.613.479-.585 1.024.028.546.34.98.688.96.348-.021.612-.48.585-1.025-.019-.533-.338-.973-.688-.959z"
          fill="#263238"
        />
        <Path
          d="M312.263 51.998l1.314.314c-.597.676-1.314-.313-1.314-.313z"
          fill="#263238"
        />
        <Path
          d="M349.922 108.535l-5.019 2.125.731 1.775 5.01-2.126-.722-1.774zM343.572 111.224l.73 1.774-4.945 2.094-.73-1.774 4.945-2.094zM330.359 116.811l-3.361 1.422.723 1.774 3.37-1.422-.732-1.774zM325.669 118.794l.732 1.774-1.476.627-.731-1.774 1.475-.627z"
          fill="#407BFF"
        />
        <Path
          d="M267.663 93.226c2.551-1.163 3.667-4.216 2.486-6.805l-4.151-9.1a.541.541 0 00-.716-.273.542.542 0 00-.263.72l4.15 9.1c.931 2.04.052 4.447-1.959 5.365-2.012.917-4.406.003-5.337-2.037l-4.365-9.571a.542.542 0 00-.717-.274.543.543 0 00-.263.72l4.366 9.571c1.181 2.589 4.218 3.748 6.769 2.584z"
          fill="#263238"
        />
        <Path
          d="M255.175 124.143l23.638-6.56c1.284-.356 2.028-1.699 1.661-3L270.6 79.598c-.367-1.3-1.706-2.066-2.991-1.709l-23.637 6.56c-1.285.356-2.028 1.7-1.661 3l9.874 34.984c.367 1.3 1.706 2.066 2.99 1.71z"
          fill="#407BFF"
        />
        <Path
          opacity={0.6}
          d="M255.175 124.143l23.638-6.56c1.284-.356 2.028-1.699 1.661-3L270.6 79.598c-.367-1.3-1.706-2.066-2.991-1.709l-23.637 6.56c-1.285.356-2.028 1.7-1.661 3l9.874 34.984c.367 1.3 1.706 2.066 2.99 1.71z"
          fill="#fff"
        />
        <Path
          opacity={0.2}
          d="M251.147 102.305l18.988-5.17a.562.562 0 01.685.397l.048.176c.083.299-.09.607-.385.687l-18.987 5.169a.56.56 0 01-.685-.396l-.049-.176a.555.555 0 01.385-.687zM252.573 107.45l18.988-5.17a.562.562 0 01.685.397l.049.175c.082.3-.09.608-.386.688l-18.987 5.17a.563.563 0 01-.686-.397l-.048-.176a.555.555 0 01.385-.687zM253.998 112.595l18.988-5.17a.561.561 0 01.685.396l.049.176a.556.556 0 01-.386.688l-18.987 5.169a.563.563 0 01-.686-.396l-.048-.176a.555.555 0 01.385-.687z"
          fill="#000"
        />
        <Path
          d="M257.727 124.62l23.35-7.51c1.268-.408 1.958-1.781 1.54-3.066L271.371 79.47c-.418-1.286-1.785-1.997-3.054-1.589l-23.349 7.51c-1.269.408-1.959 1.78-1.541 3.066l11.246 34.574c.419 1.286 1.786 1.997 3.054 1.589z"
          fill="#407BFF"
        />
        <Path
          opacity={0.7}
          d="M257.727 124.62l23.35-7.51c1.268-.408 1.958-1.781 1.54-3.066L271.371 79.47c-.418-1.286-1.785-1.997-3.054-1.589l-23.349 7.51c-1.269.408-1.959 1.78-1.541 3.066l11.246 34.574c.419 1.286 1.786 1.997 3.054 1.589z"
          fill="#fff"
        />
        <Path
          opacity={0.2}
          d="M252.84 102.953l18.76-5.934a.561.561 0 01.7.369l.055.173a.556.556 0 01-.357.703l-18.76 5.933a.56.56 0 01-.7-.368l-.055-.174a.555.555 0 01.357-.702zM254.468 108.038l18.76-5.933a.56.56 0 01.7.369l.056.174a.554.554 0 01-.358.702l-18.76 5.934a.561.561 0 01-.7-.369l-.055-.174a.556.556 0 01.357-.703zM256.095 113.124l18.76-5.934a.56.56 0 01.7.369l.055.174a.555.555 0 01-.357.702l-18.76 5.933a.56.56 0 01-.7-.368l-.055-.174a.556.556 0 01.357-.702z"
          fill="#000"
        />
        <Path
          d="M245.264 97.57l12.642 27.846a.708.708 0 00.934.359l25.379-11.521a.708.708 0 00.346-.94l-16.443-36.218a.71.71 0 00-.935-.359l-17.1 7.763-4.823 13.07z"
          fill="#407BFF"
        />
        <Path
          d="M245.264 97.57l12.642 27.846a.708.708 0 00.934.359l25.379-11.521a.708.708 0 00.346-.94l-16.443-36.218a.71.71 0 00-.935-.359l-17.1 7.763-4.823 13.07z"
          fill="#fff"
          opacity={0.8}
        />
        <Path
          d="M253.454 103.968l17.937-8.076a.558.558 0 01.736.285l.075.166a.558.558 0 01-.275.74l-17.937 8.077a.557.557 0 01-.736-.285l-.075-.166a.558.558 0 01.275-.741zM255.647 108.838l17.937-8.077a.559.559 0 01.737.285l.075.167a.559.559 0 01-.275.74l-17.937 8.077a.56.56 0 01-.737-.286l-.074-.166a.558.558 0 01.274-.74zM257.841 113.707l17.937-8.076a.558.558 0 01.736.285l.075.167a.558.558 0 01-.275.74l-17.937 8.077a.558.558 0 01-.736-.286l-.075-.166a.558.558 0 01.275-.741z"
          fill="#263238"
        />
        <Path
          d="M250.066 84.486l3.813 8.4a.708.708 0 01-.346.94l-8.253 3.746 4.786-13.086z"
          fill="#407BFF"
        />
        <Path
          opacity={0.9}
          d="M250.066 84.486l3.813 8.4a.708.708 0 01-.346.94l-8.253 3.746 4.786-13.086z"
          fill="#fff"
        />
        <Path
          opacity={0.5}
          d="M253.454 103.968l17.937-8.076a.558.558 0 01.736.285l.075.166a.558.558 0 01-.275.74l-17.937 8.077a.557.557 0 01-.736-.285l-.075-.166a.558.558 0 01.275-.741zM255.647 108.838l17.937-8.077a.559.559 0 01.737.285l.075.167a.559.559 0 01-.275.74l-17.937 8.077a.56.56 0 01-.737-.286l-.074-.166a.558.558 0 01.274-.74zM257.841 113.707l17.937-8.076a.558.558 0 01.736.285l.075.167a.558.558 0 01-.275.74l-17.937 8.077a.558.558 0 01-.736-.286l-.075-.166a.558.558 0 01.275-.741z"
          fill="#fff"
        />
        <Path
          d="M259.531 80.888l.979-.447-.778-1.705c-.605-1.326-.033-2.89 1.274-3.487 1.307-.596 2.864-.002 3.469 1.324l.551 1.208.979-.447-.551-1.207c-.855-1.875-3.054-2.714-4.901-1.871-1.847.842-2.655 3.053-1.8 4.927l.778 1.705z"
          fill="#263238"
        />
        <Path
          d="M265.745 88.958c1.157-.527 1.662-1.911 1.127-3.084l-3.588-7.868a.543.543 0 00-.717-.274.542.542 0 00-.263.72l3.589 7.868a1.239 1.239 0 01-.601 1.644 1.239 1.239 0 01-1.635-.624l-3.374-7.396a.541.541 0 00-.716-.273.542.542 0 00-.263.72l3.373 7.396c.536 1.174 1.912 1.699 3.068 1.171z"
          fill="#263238"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_5028_4425">
          <Path
            fill="#fff"
            transform="matrix(-1 0 0 1 412 -27)"
            d="M0 0H412V290H0z"
          />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default SvgComponent
